import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FilesDropDirective } from '@core/directives/files-drop.directive';
import { TranslateModule } from '@ngx-translate/core';
import { CropPhotoDialogComponent } from '../../general/crop-photo-dialog/crop-photo-dialog.component';

@Component({
  selector: 'xemex-upload-photo-dialog',
  imports: [MatIconModule, MatButtonModule, FilesDropDirective, TranslateModule],
  templateUrl: './upload-photo-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './upload-photo-dialog.component.scss',
})
export class UploadPhotoDialogComponent {
  acceptedTypes = ['image/png', 'image/jpg', 'image/jpeg'];

  titleKey = 'user.dialog.uploadAvatar.title';
  descriptionKey = 'user.dialog.uploadAvatar.desc';

  imgResult: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<UploadPhotoDialogComponent>,
    private dialog: MatDialog,
  ) {
    this.titleKey = data.title || this.titleKey;
    this.descriptionKey = data.content || this.descriptionKey;
  }

  onFileDrop(files: any) {
    this.dialog
      .open(CropPhotoDialogComponent, {
        width: '640px',
        height: '456px',
        maxWidth: '640px',
        data: {
          imageFile: files[0],
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.dialogRef.close({
            croppedImage: result.croppedImage,
            imageBlob: result.imageBlob,
          });
        }
      });
  }

  onFileSelected(event: any) {
    this.dialog
      .open(CropPhotoDialogComponent, {
        width: '640px',
        height: '456px',
        maxWidth: '640px',
        data: {
          imageFile: event.target.files[0],
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.dialogRef.close({
            croppedImage: result.croppedImage,
            imageBlob: result.imageBlob,
          });
        }
      });
  }
}
